import React, { Component } from 'react';
import { browserHistory } from 'react-router';

class BackButton extends Component {
	render() {
		return (
			<button
				type="button"
				className="btn btn-primary--ghost back"
				onClick={browserHistory.goBack}
			>
				<span className="icon">
					<i className="fa fa-arrow-left animated-left" aria-hidden="true" />
				</span>
				<span className="label">Go back</span>
			</button>
		);
	}
}

export default BackButton;



// WEBPACK FOOTER //
// src/client/components/common/elements/BackButton.js